import type { StoneLocation } from "./types";

export const LOCATION_LABEL: Record<StoneLocation, string> = {
  "renal-pelvis": "renal pelvis",
  "upper-pole-calyx": "upper-pole calyx",
  "mid-pole-calyx": "mid-pole calyx",
  "lower-pole-calyx": "lower-pole calyx",
  upj: "UPJ",
  "proximal-ureter": "proximal ureter",
  "mid-ureter": "mid ureter",
  "distal-ureter": "distal ureter",
  uvj: "UVJ",
  bladder: "bladder",
};

export const LOCATION_OPTIONS: StoneLocation[] = Object.keys(LOCATION_LABEL) as StoneLocation[];

const NUMBER_WORD = ["zero", "One", "Two", "Three", "Four", "Five", "Six"];
export function countWord(n: number): string {
  return NUMBER_WORD[n] ?? String(n);
}

export function joinList(items: string[]): string {
  if (items.length <= 1) return items[0] ?? "";
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(", ")}, and ${items[items.length - 1]}`;
}
